/**
 * Enveloppe une soumission async (mutation) : capture l'erreur pour l'afficher et
 * expose l'état d'attente. Point unique de gestion d'erreur des formulaires.
 */
import { useCallback, useState } from 'react';

export interface SubmitState {
  /** Lance l'action ; capture et expose toute erreur. */
  run: (action: () => Promise<void>) => Promise<void>;
  /** Erreur de la dernière tentative (null si succès/inactif). */
  error: string | null;
  reset: () => void;
  pending: boolean;
}

export function useSubmit(): SubmitState {
  const [error, setError] = useState<string | null>(null);
  const [pending, setPending] = useState(false);

  const run = useCallback(async (action: () => Promise<void>) => {
    setPending(true);
    setError(null);
    try {
      await action();
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Une erreur est survenue.');
    } finally {
      setPending(false);
    }
  }, []);

  const reset = useCallback(() => setError(null), []);
  return { run, error, reset, pending };
}
